
export default class BankAccountObligateRequestModel {
    public obligationDate?: Date;
    public obligationAmount: number = 0;
    public obligationFundId: number = 0;
}
